import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MetricDetailPage } from '@/features/metric-hub/metric-detail/MetricDetailPage';

/**
 * Metric detail route.
 *
 * `?v=N` lets the user view any historical approved version (the version
 * timeline writes this on click). Without `v`, the current approved
 * snapshot is rendered.
 */
export const Route = createFileRoute('/_authed/metric-hub/metrics/$slug')({
  validateSearch: z.object({
    v: z.coerce.number().int().positive().optional(),
  }),
  component: MetricDetailRoute,
});

function MetricDetailRoute() {
  const { slug } = Route.useParams();
  const { v } = Route.useSearch();
  return <MetricDetailPage slug={slug} viewingVersion={v ?? null} />;
}
